import styled from 'styled-components';

import Hamburger from 'assets/svg/Hamburger';

export const Btn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: none;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
`;

export const Icon = styled(Hamburger)`
  width: 24px;
  height: 24px;
  color: var(--color-black);
`;
